import { merge } from '@npi/buddy-utils';

import { TRIPLE_TOGGLE_PRICING_TYPES } from '../components/ThreeToggleRates';
import { ADDITIONAL_TARIFFS_PERSONAL_CARDS } from '../sections/AdditionalTariffs';
import { SAFE_PAYMENTS_OPTIONS, WORLDPAY_OPTIONS } from '../sections/CompliancePricing';
import { COMMERCIAL_CARDS, OTHER_CARDS, PERSONAL_CARDS } from '../sections/TransactionPricing';

const initialValues = {
    offerName: '',
    transactionPricing: {
        commercialCards: {
            visaDrComInt: {
                type: 'PERCENTAGE',
                percentageBaseRate: 1.8,
                percentageLowestRate: 1.8,
                percentageHighestRate: 1.8,
            },
        },
        locality: {
            interRegional: {
                purchases: {
                    percentage: 1.25,
                    costPerItem: 6.5,
                },
                refunds: {
                    percentage: 1.25,
                    costPerItem: 6.5,
                },
            },
            intraRegional: {
                purchases: {
                    percentage: 1,
                },
                refunds: {
                    percentage: 1,
                },
            },
        },
    },
};

const TransactionPricingConstants = {
    type: TRIPLE_TOGGLE_PRICING_TYPES[0].value,
    baseRate: undefined,
    percentageBaseRate: undefined,
    percentageLowestRate: undefined,
    percentageHighestRate: undefined,
    perItemBaseRate: undefined,
    perItemLowestRate: undefined,
    perItemHighestRate: undefined,
    baseRatePercentage: undefined,
};

export const ADD_TRANSACTION_PRICING_INITIAL_VALUES = () => {
    const newInitialValues = {
        personalCards: {},
        commercialCards: {},
        otherCards: {},
    };

    PERSONAL_CARDS.forEach(({ name, isConstant }) => {
        if (!isConstant) {
            newInitialValues.personalCards[name] = TransactionPricingConstants;
        }
    });

    COMMERCIAL_CARDS.forEach(({ name, isConstant }) => {
        if (!isConstant) {
            newInitialValues.commercialCards[name] = TransactionPricingConstants;
        }
    });

    OTHER_CARDS.forEach(({ name, isConstant }) => {
        if (!isConstant) {
            newInitialValues.otherCards[name] = TransactionPricingConstants;
        }
    });

    const additionalTariffs = { personalCards: {} };

    ADDITIONAL_TARIFFS_PERSONAL_CARDS.forEach(({ isConstant, name }) => {
        if (!isConstant) {
            additionalTariffs.personalCards[name] = {
                type: ['authorisationFee', 'minMonthlyServiceFee'].includes(name)
                    ? 'PER_ITEM'
                    : 'FIXED',
                baseRate: undefined,
                lowestRate: undefined,
                highestRate: undefined,
                fixedRate: undefined,
            };
        }
    });

    const compliancePricing = { worldpayProgramme: {}, safePayments: {} };

    SAFE_PAYMENTS_OPTIONS.forEach(({ isConstant, name }) => {
        if (!isConstant) {
            compliancePricing.safePayments[name] = {
                type: 'PER_ITEM',
                baseRate: undefined,
                lowestRate: undefined,
                highestRate: undefined,
                fixedRate: undefined,
            };
        }
    });

    WORLDPAY_OPTIONS.forEach(({ isConstant, name }) => {
        if (!isConstant) {
            compliancePricing.worldpayProgramme[name] = {
                type: 'PER_ITEM',
                baseRate: undefined,
                lowestRate: undefined,
                highestRate: undefined,
                fixedRate: undefined,
            };
        }
    });

    const manageEligibility = {
        terminalOffers: [],
        onlineOffers: [],
        mccs: [],
    };

    return merge(
        {
            ...manageEligibility,
            offerName: undefined,
            revenueShare: undefined,
            additionalTariffs,
            compliancePricing,
            transactionPricing: newInitialValues,
        },
        initialValues
    );
};
